var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.dialogVisible,
        title: "名额",
        width: "50%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", [
        _c("p", [
          _vm._v(
            " 你可以为每个选项设定名额。每次有人选择，就会占用1个名额，直至名额用完。同时你也可以自定义名额用完之后的文案提示。 "
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "el-form el-form--label-top",
            staticStyle: { "margin-top": "20px" },
          },
          [
            _c("div", { staticClass: "el-form-item" }, [
              _c(
                "div",
                {
                  staticClass: "el-form-item__label",
                  staticStyle: { display: "flex" },
                },
                [
                  _c("div", { staticStyle: { flex: "1" } }, [
                    _c("b", [_vm._v("选项设置")]),
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: { trigger: "click", width: "300" },
                          model: {
                            value: _vm.quotaSettingVisible,
                            callback: function ($$v) {
                              _vm.quotaSettingVisible = $$v
                            },
                            expression: "quotaSettingVisible",
                          },
                        },
                        [
                          _c("div", [
                            _c("p", [_vm._v("名额设置")]),
                            _c(
                              "div",
                              { staticStyle: { margin: "10px 0" } },
                              [
                                _c("el-input-number", {
                                  staticClass: "w100",
                                  attrs: { min: 0, placeholder: "请输入" },
                                  model: {
                                    value: _vm.quota,
                                    callback: function ($$v) {
                                      _vm.quota = $$v
                                    },
                                    expression: "quota",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "el-popconfirm__action" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onQuotaSetting()
                                        },
                                      },
                                    },
                                    [_vm._v("确定")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          _vm.quotaSettingVisible = false
                                        },
                                      },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "reference", type: "text" },
                              slot: "reference",
                            },
                            [_vm._v("批量设置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "el-form-item__content" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        border: "",
                        data: _vm.copyActiveData.config.options,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "选项", property: "label" },
                      }),
                      _c("el-table-column", {
                        attrs: { property: "quotaSetting", label: "名额设置" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input-number", {
                                  staticClass: "w100",
                                  attrs: { min: 0, placeholder: "请输入" },
                                  model: {
                                    value: scope.row.quotaSetting,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "quotaSetting", $$v)
                                    },
                                    expression: "scope.row.quotaSetting",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "剩余名额", property: "quotaSetting" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.quotaSetting
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getSurplusQuota(scope.row)
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "el-form-item" }, [
              _c("div", { staticClass: "el-form-item__label" }, [
                _c("b", [_vm._v("剩余名额为0时，显示文案")]),
                _vm._v("(仅限20个字符)"),
              ]),
              _c(
                "div",
                { staticClass: "el-form-item__content" },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.copyActiveData.config.quotaBlankWarning,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.copyActiveData.config,
                          "quotaBlankWarning",
                          $$v
                        )
                      },
                      expression: "copyActiveData.config.quotaBlankWarning",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "el-form-item" }, [
              _c(
                "div",
                { staticClass: "el-form-item__label" },
                [
                  _c("b", [_vm._v("选项名额重置")]),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        content:
                          "勾选后，名额可按「天」「周」自动重置。每天重置时间为0点，每周重置时间为每周日晚上0点。\n            系统将在00:00-00:30 进行名额重置，期间表单不可填写。重置期间请勿修改数据详情。",
                        effect: "dark",
                        placement: "top-start",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item__content" },
                [
                  _c(
                    "el-radio-group",
                    {
                      directives: [
                        {
                          name: "removeAriaHidden",
                          rawName: "v-removeAriaHidden",
                        },
                      ],
                      model: {
                        value: _vm.copyActiveData.config.quotaCycleRule,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.copyActiveData.config,
                            "quotaCycleRule",
                            $$v
                          )
                        },
                        expression: "copyActiveData.config.quotaCycleRule",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "fixed" } }, [
                        _vm._v("不重置"),
                      ]),
                      _c("el-radio", { attrs: { label: "per_day" } }, [
                        _vm._v("按天"),
                      ]),
                      _c("el-radio", { attrs: { label: "per_week" } }, [
                        _vm._v("按周"),
                      ]),
                    ],
                    1
                  ),
                  _c("div"),
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value:
                              _vm.copyActiveData.config
                                .hideChoiceWhenQuotaEmpty,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.copyActiveData.config,
                                "hideChoiceWhenQuotaEmpty",
                                $$v
                              )
                            },
                            expression:
                              "copyActiveData.config.hideChoiceWhenQuotaEmpty",
                          },
                        },
                        [_vm._v("不向填表者展示选项名额剩余数字 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.copyActiveData.config.hideQuota,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.copyActiveData.config,
                                "hideQuota",
                                $$v
                              )
                            },
                            expression: "copyActiveData.config.hideQuota",
                          },
                        },
                        [_vm._v("选项名额为空时隐藏选项")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveQuotaSetting } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }